import { DropdownMenuItem } from "@certa/catalyst/components/Dropdown";
import { WrapperWithIcon } from "../common";
import { getStudioAuditLogsRoute } from "@certa/common/utils/routes";
import { useNavigate } from "react-router";
import { Book } from "@certa/icons/components/Book";

export const ActivityLogs = () => {
  const navigate = useNavigate();

  return (
    <DropdownMenuItem
      key="activity-logs"
      value={"Activity Logs"}
      onSelect={() => navigate(getStudioAuditLogsRoute())}
    >
      <WrapperWithIcon icon={<Book />}>Activity Logs</WrapperWithIcon>
    </DropdownMenuItem>
  );
};
